<template>
  <div>
    <v-btn
      color="secondary"
      dark
      @click="dialogs.picker.display = true"
    >
      <v-icon
        class="mr-2"
        small
      >
        language
      </v-icon>
      {{ current.locale }}
      <v-icon>
        arrow_drop_down
      </v-icon>
    </v-btn>
    <v-dialog
      v-model="dialogs.picker.display"
      max-width="300"
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in options"
          :key="index"
          @click="[$i18n.locale = item.locale, dialogs.picker.display = false]"
        >
          <v-list-item-title>
            {{ item.nativeName }}
          </v-list-item-title>
          <v-list-item-action>
            <v-list-item-action-text>
              {{ item.locale.toUpperCase() }}
            </v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>

<script>
import ISO6391 from 'iso-639-1'

export default {
  name: 'LanguagePicker',

  data () {
    return {
      dialogs: {
        picker: {
          display: false,
        },
      },
    }
  },

  computed: {
    current () {
      return this.options
        .find((item) => item.locale === this.$i18n.locale)
    },

    options () {
      return this.$i18n.availableLocales
        .map(locale => ({
          locale,
          nativeName: ISO6391.getNativeName(locale),
        }))
    },
  },
}
</script>
